import styled from 'styled-components'

const ValueActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 8px;
  height: 100%;
`

export default ValueActions